import { AccountOrdersPage } from "@/components/account/orders/page"

export default function MinhaContaPedidosPage() {
  return <AccountOrdersPage />
}
